<template>
  <div class="balance">
    <div class="balance__inner">
      <div class="balance__block">
        <div class="balance__block-inner">
          <p>
            {{ amount }}
            <img src="@icons/feathers.svg" alt="feathers">
          </p>
          <el-slider
              v-model="amount"
              :min="paymentMinimum"
              :max="paymentMaximum"
              :step="5"
          />
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="25" viewBox="0 0 35 25" fill="none">
          <path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5V3.5ZM34.3536 4.35355C34.5488 4.15829 34.5488 3.84171 34.3536 3.64645L31.1716 0.464466C30.9763 0.269204 30.6597 0.269204 30.4645 0.464466C30.2692 0.659728 30.2692 0.976311 30.4645 1.17157L33.2929 4L30.4645 6.82843C30.2692 7.02369 30.2692 7.34027 30.4645 7.53553C30.6597 7.7308 30.9763 7.7308 31.1716 7.53553L34.3536 4.35355ZM1 4V4.5H34V4V3.5H1V4Z" fill="#008ECC"/>
          <path d="M34 21.5C34.2761 21.5 34.5 21.2761 34.5 21C34.5 20.7239 34.2761 20.5 34 20.5L34 21.5ZM0.646446 20.6464C0.451183 20.8417 0.451183 21.1583 0.646446 21.3536L3.82843 24.5355C4.02369 24.7308 4.34027 24.7308 4.53553 24.5355C4.7308 24.3403 4.7308 24.0237 4.53553 23.8284L1.70711 21L4.53553 18.1716C4.7308 17.9763 4.7308 17.6597 4.53553 17.4645C4.34027 17.2692 4.02369 17.2692 3.82843 17.4645L0.646446 20.6464ZM34 21L34 20.5L1 20.5L1 21L1 21.5L34 21.5L34 21Z" fill="#008ECC"/>
        </svg>
        <div class="balance__block-inner">
          <p>{{ amount }} EUR</p>
          <el-slider
              v-model="amount"
              :min="paymentMinimum"
              :max="paymentMaximum"
              :step="5"
          />
        </div>
      </div>
      <ui-checkbox
          v-model="isAgree"
          :id="1"
      >
        <i18n-t tag="p" scope="global" keypath="checkboxes.accept">
          <template #terms>
            <router-link
                class="balance__link"
                :to="translations.i18nRoute({ name: 'home' })"
            >
              {{ t('docs.terms.title') }}
            </router-link>
          </template>
          <template #policy>
            <router-link
                class="balance__link"
                :to="translations.i18nRoute({ name: 'home' })"
            >
              {{ t('docs.policy.title') }}
            </router-link>
          </template>
        </i18n-t>
      </ui-checkbox>
      <p class="balance__text">
        <i18n-t tag="span" scope="global" keypath="profile.balance.text">
          <template #paymentGatewayMinimum>
            <span>{{ paymentMinimum }}</span>
          </template>
          <template #paymentGatewayMaximum>
            <span>{{ paymentMaximum }}</span>
          </template>
        </i18n-t>
        <span>1 Feather = 1 Euro</span>
      </p>
    </div>
    <router-link :to="translations.i18nRoute({ name: 'checkout', query: { amount: amount }})">
      <ui-button
          class="balance__button"
          :isDisabled="!isFormValid"
      >
        {{ t('buttons.topUp') }}
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
          <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#008ECC" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </ui-button>
    </router-link>
  </div>
</template>

<script setup>
import UiButton from "@/components/ui/ui-button.vue";
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref} from "vue";
import translations from "@/core/helpers/translations.js";
import UiCheckbox from "@/components/ui/ui-checkbox.vue";
import {Processes} from "@/core/api/processes.js";

const {t} = useI18n()

const paymentMinimum = ref(null)
const paymentMaximum = ref(null)

const amount = ref(10)
const isAgree = ref(false)

const validateNumberInput = (event) => {
  amount.value = event.target.value.replace(/[^0-9]/g, '');
}

const isFormValid = computed(() => {
  return (
      isAgree.value === true &&
      amount.value >= paymentMinimum.value &&
      amount.value <= paymentMaximum.value
  )
})

onMounted( async () => {
  const res = await Processes.getPaymentLimits()
  paymentMinimum.value = res.data.paymentsLimits.minAmount
  paymentMaximum.value = res.data.paymentsLimits.maxAmount
})
</script>

<style lang="scss" scoped>
.balance {
  padding: 50px;
  background-color: #FBFBFB;
  background-image: url(@images/profileBg.png);
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 60px;

  &__inner {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__block {
    display: flex;
    align-items: center;
    gap: 15px;

    &-inner {
      border-radius: 16px;
      border: 1px solid #008ECC;
      background-color: $white;
      box-shadow: 0 0 14.6px 0 rgba(0, 0, 0, 0.05);
      padding: 10px 20px;
      display: flex;
      align-items: center;
      gap: 15px;
      height: 45px;
      width: 285px;

      & p {
        color: #008ECC;
        font-size: 21px;
        font-weight: 500;
        line-height: 27px;
      }

      & input {
        height: 100%;

        color: #222;
        font-size: 21px;
        font-weight: 500;
        line-height: 27px;
      }
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 5px;

    color: #222;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: -0.16px;
  }

  &__link {
    transition: 0.2s;
    color: #008ECC;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: -0.16px;
    text-decoration: underline;

    @include hover {
      color: #006699;
    }
  }

  &__button {
    width: fit-content;
    padding: 10px 20px;
  }
}

:deep(.el-slider) {
  width: 150px;
}

@media (max-width: 1300px) {
  .balance {
    flex-direction: column-reverse;
    gap: 20px;
  }
}

@media (max-width: 1000px) {
  .balance {
    &__block {
      & div {
        //width: 150px;

        & input {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .balance {
    padding: 25px;

    &__block {
      flex-direction: column;

      & svg {
        transform: rotate(90deg);
      }
    }
  }

  :deep(.el-slider) {
    width: 100px;
  }
}
</style>